import React from 'react';
import { Modal } from '../../../components';
import { selectInquiryError, selectInquiryInProgress, sendInquiry } from '../ListingPage.duck';
import OfferForm from './OfferForm';

import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { selectCurrentUser } from '../../../ducks/user.duck';
import moment from 'moment';
import { useRouteConfiguration } from '../../../context/routeConfigurationContext';
import { createResourceLocatorString } from '../../../util/routes';

function OfferModal(props) {
  const {
    onManageDisableScrolling,
    onOpenOffersModal,
    isOffersModalOpen,
    config,
    listingTitle,
    authorDisplayName,
    listing,
  } = props;

  const history = useHistory();
  const dispatch = useDispatch();
  const routes = useRouteConfiguration();
  const currentUser = useSelector(selectCurrentUser);
  const inquiryInProgress = useSelector(selectInquiryInProgress);
  const inquiryError = useSelector(selectInquiryError);

  const onSendOfferRequest = async values => {
    const { price } = values;
    const offerPrice = Number(price?.amount / 100).toFixed(2);

    const offerParams = {
      offerPrice,
      authorId: currentUser?.id?.uuid,
      createdAt: moment().unix(),
      type: 'initial',
    };

    try {
      await dispatch(sendInquiry(listing, null, offerParams));

      // The buyer's offers, where this one now waits for the seller
      history.push(createResourceLocatorString('OffersPage', routes, {}, {}));
    } catch (error) {
      // The window says why (sendInquiryError in the store)
    }
  };

  const offersModal = (
    <Modal
      id="OfferModal"
      isOpen={!!isOffersModalOpen}
      onClose={() => onOpenOffersModal(false)}
      usePortal
      onManageDisableScrolling={onManageDisableScrolling}
    >
      <OfferForm
        onSubmit={onSendOfferRequest}
        config={config}
        listingTitle={listingTitle}
        inquiryInProgress={inquiryInProgress}
        sendEnquiryError={inquiryError}
        authorDisplayName={authorDisplayName}
      />
    </Modal>
  );

  return <div>{offersModal}</div>;
}

export default OfferModal;
